export default "__VITE_ASSET__DyCBm0_Z__"